
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClientService, UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { throwError } from 'rxjs';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { TransactionReportModel } from '../models/transaction-report.model';
import { ANALYTICS_CONSTANTS } from 'config';

@Injectable()
export class TransactionService {

    constructor(private http: HttpClient,
     private httpClientService: HttpClientService,
     private utilityService: UtilityService,
     private adobeAnalyticsService: AdobeAnalyticsService) { }

 get_headers() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return headers;
  }

    fetchJSON(dataurl) {
    return this.httpClientService.get(dataurl, this.get_headers())
    .pipe(
       map((res: HttpResponse<any>) => {
      if (sessionStorage.getItem('sapmp_jwtToken') != null) {
        // refreshes token for logged in scenario upon page load
        this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
      }
     return res.body;
    })
      ,catchError( this.handleError ));
  }

    doRequestReport(url) {
        return this.httpClientService.get(url, this.get_headers())
            .pipe(
       map((res: HttpResponse<any>) => res.body)
            ,catchError( this.handleError ));
    }
    handleError = (error) => {
        return throwError(error);
    }

    setReportModel(reportRequest: TransactionReportModel) {
        sessionStorage.setItem('savedReportRequest', JSON.stringify(reportRequest));
    }

    getReportModel() {
        return JSON.parse(sessionStorage.getItem('savedReportRequest')) || new TransactionReportModel();
    }

    removeReportModel() {
      sessionStorage.removeItem('savedReportRequest');
    }
    getReportPageConfig(url) {
        return this.httpClientService.get(url)
            .pipe(
       map((res: HttpResponse<any>) => res.body)
            ,catchError( this.handleError ));
    }
  getFANList() {
    let fanUrl;   
    fanUrl = this.utilityService.getEnvConfig().getFANList;    
    return this.fetchJSON(fanUrl);
  }

  validateCTN(ctn) {
    let url;
    if (this.utilityService.getEnvConfig().useMock) {
      url = this.utilityService.getEnvConfig().getCTNMock[0];
    } else {
      url = this.utilityService.getEnvConfig().getCTN + '?ctn=' + ctn;
  }
    return this.fetchJSON(url);
  }


  createPageLoadProperties(url, sitesection2) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS['FRIENDLY_NAME_REQUEST_REPORTS_' + url];
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_REPORTS;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SITE_SECTION1] = 'transaction';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SITE_SECTION2] = sitesection2;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'home';
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }
}
